export var BannerType;
(function (BannerType) {
    BannerType["Card"] = "card";
    BannerType["Light"] = "light";
    BannerType["Dark"] = "dark";
})(BannerType || (BannerType = {}));
export var BannerSize;
(function (BannerSize) {
    BannerSize["Small"] = "small";
    BannerSize["Medium"] = "medium";
    BannerSize["Large"] = "large";
})(BannerSize || (BannerSize = {}));
